import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteByIdParamPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParam/deleteByIdParamPosInsatallment',
      requesterInfo,
    })
  }

  public async deleteByIdParamPosInsatallment(request: number): Promise<CommonPostResponse> {
    this.props.url = `${this.props.url}?Id=${request}`
    return await this.postAsync<CommonPostResponse>()
  }
}
